"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatsigUser = void 0;
const react_1 = require("react");
const StatsigContext_1 = require("./StatsigContext");
const useStatsigClient_1 = require("./useStatsigClient");
function useStatsigUser() {
    const { client } = (0, useStatsigClient_1.useStatsigClient)();
    const { renderVersion } = (0, react_1.useContext)(StatsigContext_1.default);
    const deps = [client, renderVersion];
    const memoUser = (0, react_1.useMemo)(() => {
        const context = client.getContext();
        return context.user;
    }, deps);
    return {
        user: memoUser,
        updateUserSync: (0, react_1.useCallback)((arg) => {
            if (typeof arg === 'function') {
                arg = arg(memoUser);
            }
            client.updateUserSync(arg);
        }, deps),
        updateUserAsync: (0, react_1.useCallback)((arg) => {
            if (typeof arg === 'function') {
                arg = arg(memoUser);
            }
            return client.updateUserAsync(arg);
        }, deps),
    };
}
exports.useStatsigUser = useStatsigUser;
